import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  items: FAQItem[];
}

export default function FAQ({ items }: FAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="space-y-3">
      {items.map((item, index) => (
        <div
          key={index}
          className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden"
        >
          <button
            className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
            onClick={() => toggle(index)}
            aria-expanded={openIndex === index}
          >
            <span className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
              {item.question}
            </span>
            <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
              <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
            </div>
          </button>
          <div
            className={`overflow-hidden transition-all duration-300 ${
              openIndex === index ? 'max-h-[500px] pb-5 px-5' : 'max-h-0'
            }`}
          >
            <p className="text-sm text-foreground-600 leading-relaxed">
              {item.answer}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}